import styled from "styled-components";
import { STYLE_CONSTS } from "~/src/styles/config.style";

export const PoolConnectionsWrapper = styled.div`
  margin-left: ${STYLE_CONSTS.UNIT_8};
  margin-top: ${STYLE_CONSTS.UNIT_4};
  margin-bottom: ${STYLE_CONSTS.UNIT_2};
`;
